import '../slide-tray/jquery.dst';
import '../slide-tray/jquery.dst-extensions';
import '../slide-tray/jquery.dst.scss';
import '../slide-tray/cm_default.scss';

// Add the links to uScope
import '../slide-tray/uScope-extensions/dst-wrapper/index';
import '../slide-tray/uScope-extensions/mark-as-read/index';

// Add the workflow to the viewer.
import '../slide-tray-workflow';



// WEBPACK FOOTER //
// ./src/lib/slide-tray.js